<template>
    <div class="container">
        <!-- 左侧内容 -->
        <div class="left-column">
            <!-- 在这里放置左侧内容 -->
            <el-menu default-active="0" class="el-menu-vertical-demo" style="height:calc(100vh - 110px);overflow-y: auto;overflow-x: hidden;">
                <el-menu-item :index="i" :key="i" v-for="(item,i) in dict_data" @click="handleDict(item)">
                    <i class="el-icon-document"></i>
                    <span slot="title">{{item.dictName}}</span>
                </el-menu-item>
            </el-menu>
        </div>
        <!-- 中间分隔线 -->
        <div class="separator"></div>
        <!-- 右侧内容 -->
        <!--工具条-->
        <div class="right-column">
            <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                <el-form :inline="true" :model="filters">
                    <el-form-item>
                        <el-button type="primary" v-on:click="addInfo" :disabled="currentRow.isRead==1" size="small">增加一行</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="saveInfo" :disabled="currentRow.isRead==1" size="small">批量保存</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
            <el-table :data="grid_data" height="calc(100vh - 170px)" border highlight-current-row v-loading="listLoading"
                style="width: 100%;">
                <el-table-column prop="keyValue" label="键值" width="150" v-if="currentRow.saveMode==1">
                    <template scope="scope">
                        <el-input v-model="scope.row.keyValue" auto-complete="off" size="small" maxLength="100"  :disabled="scope.row.isRead==1" />
                    </template>
                </el-table-column>
                <el-table-column prop="keyName" label="键值名称" width="150">
                    <template scope="scope">
                        <el-input v-model="scope.row.keyName"  auto-complete="off" size="small" maxLength="100"  :disabled="scope.row.isRead==1"/>
                    </template>
                </el-table-column>
                <el-table-column prop="sortNum" label="排序(大到小)" width="150">
                    <template scope="scope">
                        <el-input v-model="scope.row.sortNum" type="Number"  auto-complete="off" size="small" maxLength="100" />
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="250">
                    <template scope="scope">
                        <el-button size="small" :disabled="currentRow.isRead==1 || scope.row.isRead==1" @click="delInfo(scope.$index, scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
 
<style scoped lang="scss">
.container {
    display: flex;
}

/* 定义左侧列样式 */
.left-column {
    width: 20%;
    background-color: #f1f1f1;
    .el-menu-item:hover {
     background-color: #409EFF !important; 
     color:#ffffff !important; 
    }
}

/* 定义右侧列样式 */
.right-column {
    width: 80%;
    background-color: #ffffff;
}

/* 定义中间分隔线样式 */
.separator {
    width: 1px;
    height: calc(100vh - 110px);
    margin: auto;
    background-color: #e9e4e4;
}
</style>
<script>
export default {
    data() {
        return {
            filters: {
                keyId: '',
                rows: 10000,
                page: 1
            },
            grid_data: [],
            total: 0,
            listLoading: false,
            sels: [],//列表选中列
            showTitle: "",
            dialogAddShow: false,
            mid: 0,
            dict_data:[],
            currentRow:{isRead:0,saveMode:1},
        }
    },
    methods: {
        handleDict(row) {
            this.currentRow=row;
            this.filters.keyId = row.dictKey;
            this.getGridData();
        },
        handleSizeChange(val) {
            this.filters.rows = val;
            this.getGridData();
        },
        handleCurrentChange(val) {
            this.filters.page = val;
            this.getGridData();
        },
        getDictList(){
            let formData = this.$util.jsonToForm( { rows: 10000,page: 1,dictType:0});
            this.$axios.post("/basic/getbasic_dictlist", formData).then(res => {
                this.dict_data = res.data.data;
                this.handleDict(this.dict_data[0]);
            });
        },
        //获取列表
        getGridData() {
            this.listLoading = true;
            let formData = this.$util.jsonToForm(this.filters);
            this.$axios.post("/basic/getsysdictionarylist", formData).then(res => {
                this.listLoading = false;
                this.total = res.data.total;
                this.grid_data = res.data.data;
            });
        },
        //删除
        delInfo: function (index, row) {
            this.grid_data.splice(index,1);
        },
        addInfo: function () {
            this.grid_data.push({
                id: 0,
                keyId: this.filters.keyId,
                keyValue: '',
                keyName: '',
                typeName: '',
                sortNum: 0
            });
        },
        saveInfo: function () {
            if(this.filters.keyId==""){
                return;
            }
            if(this.grid_data.length==0){
                this.$message("请录入数据!");
                return;
            }
            if(this.currentRow.saveMode==2){
                this.grid_data.map(v=>v.keyValue=v.keyName)
            }
            let addForm={keyId:this.filters.keyId,data:JSON.stringify(this.grid_data)};
            let formData = this.$util.jsonToForm(addForm);
            this.$axios.post("/basic/sysdictionarysave", formData).then(res => {
                if (res.data.status == 0) {
                    this.$message("保存成功!");
                } else {
                    this.$message(res.data.msg);
                }
            });
        }
    },
    created() {
      this.getDictList()
    }
}
</script>